/**
 * The client's day-sheet, row by row, as they write it — chapter 1 maps
 * every column of THIS table to the screen that replaced it. Names and
 * colours match the live Australia plan so the operator recognises them.
 * For Media Devoted | Created By Ciro Autiero
 */
import type { EditorTabKey } from '../../editor/EditorTabs';

export interface SheetRow {
  tag: string;
  color: string;
  list: string;
  start: string;
  every: string;
  amounts: string;
  route: string;
  duplicate: boolean;
  text: string;
  sender: string;
  enabled: boolean;
}

export const DEMO_SHEET: SheetRow[] = [
  { tag: 'WARM UP', color: '#6366f1', list: 'clickers', start: '11:00', every: '35 min', amounts: '5 × 500 → 2 × 1,000', route: 'A (hold)', duplicate: false, text: 'General', sender: 'AU senders', enabled: true },
  { tag: 'CLEARANCE-FTDs', color: '#ec4899', list: 'FTDs', start: 'after prev + 3', every: '20 min', amounts: '400', route: 'B', duplicate: true, text: 'General', sender: 'AU senders', enabled: true },
  { tag: 'RAW (TOP TEXT PROMPT)', color: '#14b8a6', list: 'raw', start: '14:00', every: '25 min', amounts: '500', route: 'A', duplicate: false, text: 'Top prompt', sender: 'AU senders', enabled: true },
  { tag: 'CLEARANCE-CLICKS', color: '#f59e0b', list: 'clickers', start: '14:00 → 21:00', every: '15 min', amounts: '300', route: 'A / B', duplicate: true, text: 'General', sender: 'AU senders', enabled: true },
  { tag: 'ACE DROPS', color: '#8b5cf6', list: 'ACE', start: '16:00', every: '35 min', amounts: '700', route: 'A', duplicate: false, text: 'ACE', sender: 'AU senders', enabled: true },
  { tag: 'NEW', color: '#0ea5e9', list: 'new lists', start: 'after prev + 9', every: '30 min', amounts: '600', route: 'A', duplicate: false, text: 'General', sender: 'AU senders', enabled: true },
  { tag: 'SEGMENTS', color: '#ec4899', list: 'clickers + FTDs', start: 'after prev + 10', every: '60 min', amounts: '800 (one 900)', route: 'A / B', duplicate: false, text: 'General', sender: 'AU senders', enabled: true },
  { tag: 'NIGHT', color: '#64748b', list: 'clickers', start: '00:30 → 11:30', every: '45 min', amounts: '500', route: 'B', duplicate: false, text: 'General', sender: 'AU senders', enabled: false },
  { tag: 'ROUTE TEST', color: '#16a34a', list: 'clickers', start: 'after prev + 21', every: '50 min', amounts: '1,000', route: 'A, B, C, D', duplicate: false, text: 'General', sender: 'AU senders', enabled: true },
];

export interface SheetColumn {
  key: keyof SheetRow;
  label: string;
  /** Where the column lives now, in client words. */
  home: string;
  etab?: EditorTabKey;
}

export const SHEET_COLUMNS: SheetColumn[] = [
  { key: 'tag', label: 'TAG', home: 'the container name and colour on the Board' },
  { key: 'list', label: 'LIST', home: 'List groups — a rule, not a list', etab: 'groups' },
  { key: 'start', label: 'START', home: 'Schedule — start mode and time', etab: 'general' },
  { key: 'every', label: 'EVERY', home: 'Schedule — interval', etab: 'general' },
  { key: 'amounts', label: 'AMOUNTS', home: 'Drop slots — one amount per slot', etab: 'general' },
  { key: 'route', label: 'ROUTE', home: 'Gateways — pool and strategy', etab: 'gateways' },
  { key: 'duplicate', label: 'DUPLICATE', home: 'Options — send defaults', etab: 'options' },
  { key: 'text', label: 'TEXT', home: 'Creative — prompt groups', etab: 'creative' },
  { key: 'sender', label: 'SENDER', home: 'Gateways — senders on each row', etab: 'gateways' },
];
